// Markup from design/kit/components/EmptyState: one line and at most one button.
type EmptyStateProps = {
  text: string;
  action?: { label: string; onClick: () => void };
};

export function EmptyState({ text, action }: EmptyStateProps) {
  return (
    <div className="gcard empty">
      <span className="t13 w5 ink">{text}</span>
      {action && (
        <button type="button" className="btn btn-sm" onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  );
}
